import instance from "./baseRequest";

export const privacyPolicyApi = {
  getPrivacyPolicy: async () => await instance.get("/privacy-policy"),
  updatePrivacyPolicy: async (data) => await instance.put("/privacy-policy", data),
};
